import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['RM', 'Roxana M.', 'Buenos Aires', 'Dejé de improvisar. Ahora tengo frases listas y sé cuándo pausar. Las discusiones bajaron muchísimo.'], ['VS', 'Valeria S.', 'La Plata', 'El semáforo de tensión me salvó. Identifico a tiempo cuándo todo se va a descontrolar y freno antes.'], ['DR', 'Daniela R.', 'Quilmes', 'Por primera vez siento que no estoy sola. Tengo un plan para cada momento difícil y eso me da paz.'], ['SG', 'Silvia G.', 'San Isidro', 'Mi papá sigue teniendo el Párkinson, pero la relación cambió. Ahora nos comunicamos mejor, sin tanto enojo.']] as const;
const extended = [['ML', 'Marta L.', 'Flores', '“Llegué al punto de gritar todos los días. Ahora uso el protocolo y las cosas son distintas. Menos tensión, más claridad.”'], ['PG', 'Patricia G.', 'Córdoba', '“Las frases preparadas me ayudaron muchísimo. Ya no me quedo pensando qué decir cuando rechaza mi ayuda.”'], ['CR', 'Claudia R.', 'Rosario', '“Lo que más me ayudó fue tener un plan. Ahora, cuando aparece una situación difícil, sé por dónde empezar.”'], ['LP', 'Laura P.', 'Mendoza', '“Ahora puedo reconocer cuándo insistir y cuándo darle espacio. Eso cambió mucho la forma de acompañarlo.”']] as const;
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-170" data-mp="1ucw2yc0tsjhh">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-171" data-mp="1zap7l0mhd5fn" />)}
    </div>;
}
export function StatsAndProof() {
  const stats = [['+380', 'cuidadoras ya usando el sistema'], ['3', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['4.8/5', 'calificación']];
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-172" data-mp="2e0wmj6da46bl">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-173" data-mp="2i2zwtro7p4va">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-174" data-mp="2n2ct130z3oaj">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-175" data-mp="mz1vibfu56sz">
                {value}
              </p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-176" data-mp="ixqf8wiupxxg">
                {label}
              </p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-177" data-mp="ry5425v0xv5p">
        <div className="mx-auto max-w-6xl" data-id="element-178" data-mp="rwlibzqlmrwj">
          <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-179" data-mp="16msvq11r1kqd">
            💬 LO QUE DICEN LAS CUIDADORAS
          </h2>
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4" data-id="element-180" data-mp="11q2evbi4el3w">
            {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className="flex h-full flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-181" data-mp="1aow7yrw8stcp" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-182" data-mp="1s01rwvo0uamv">
                  <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-183" data-mp="1ww099zaxmsds">
                    {initials}
                  </div>
                  <div data-id="element-184" data-mp="1n67178a00vea">
                    <h3 className="font-bold" data-id="element-185" data-mp="1n5fg4re12g29">{name}</h3>
                    <p className="text-sm text-slate-400" data-id="element-186" data-mp="1977motg79wvu">{place}</p>
                  </div>
                </div>
                <div className="mt-5" data-id="element-187" data-mp="1e7lind4j1gdi">
                  <Stars data-id="element-188" data-mp="1e4h9e1c7fufz" />
                </div>
                <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-189" data-mp="107kla7nh0r2s">
                  “{quote}”
                </p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-190" data-mp="2uiphiqw8a183">
      <div className="mx-auto max-w-5xl" data-id="element-191" data-mp="2ylm5yy8g8rjy">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-192" data-mp="29vhnofyb5x0k">
          🌿 LO QUE CAMBIÓ PARA ELLAS
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-193" data-mp="24xg0pjxrhdjt">
          {extended.map(([initials, name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-194" data-mp="1zvqs0ay0hbyw">
              <div className="flex items-center gap-3" data-id="element-195" data-mp="1uxyy5bdt3fs2">
                <div className="grid h-9 w-9 shrink-0 place-items-center rounded-full border border-brand-green/40 text-sm font-bold text-brand-light" data-id="element-196" data-mp="1qwn854r0ssjc">
                  {initials}
                </div>
                <p className="font-bold" data-id="element-197" data-mp="1h6kdz185x8jf">
                  {name}{' '}
                  <span className="font-normal text-slate-400" data-id="element-198" data-mp="1h4r3tbycc66o">· {place}</span>
                </p>
              </div>
              <div className="mt-2" data-id="element-199" data-mp="178o40cqyojmw">
                <Stars data-id="element-200" data-mp="177mifecbkeqx" />
              </div>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-201" data-mp="17aqwd3fl6ous">
                {quote}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}